import { Button } from "@/components/ui/button";
import { Calendar, ChevronLeft, ChevronRight } from "lucide-react";
import { isSameDay } from "@/utils/helpers";

interface DateSelectorProps {
    selectedDate: Date;
    onDateChange: (date: Date) => void;
}

export function DateSelector({
    selectedDate,
    onDateChange,
}: DateSelectorProps) {
    const today = new Date();
    const isToday = isSameDay(selectedDate, today);

    const goToPrevDay = () => {
        const prev = new Date(selectedDate);
        prev.setDate(prev.getDate() - 1);
        onDateChange(prev);
    };

    const goToNextDay = () => {
        const next = new Date(selectedDate);
        next.setDate(next.getDate() + 1);
        onDateChange(next);
    };

    const goToToday = () => {
        onDateChange(today);
    };

    return (
        <div className="flex items-center gap-1">
            <Button
                size="icon"
                variant="ghost"
                onClick={goToPrevDay}
                className="h-9 w-9"
            >
                <ChevronLeft className="w-4 h-4" />
            </Button>
            <Button
                variant={isToday ? "default" : "outline"}
                onClick={goToToday}
                className="min-w-[100px] sm:min-w-40 gap-2 font-medium text-sm sm:text-base"
            >
                <Calendar className="w-4 h-4 hidden sm:block" />
                {isToday
                    ? "Today"
                    : selectedDate.toLocaleDateString("en-US", {
                          weekday: "short",
                          month: "short",
                          day: "numeric",
                      })}
            </Button>
            <Button
                size="icon"
                variant="ghost"
                onClick={goToNextDay}
                disabled={isToday}
                className="h-9 w-9"
            >
                <ChevronRight className="w-4 h-4" />
            </Button>
        </div>
    );
}
